export const ALL_CHANNELS = 'All';
export const DEMAND_GEN = 'Demand Generation';
export const DEMAND_CAP = 'Demand Capture';
export const DEMAND_GEN_VS_CAP = 'Demand Gen vs Capture';
export const SINGLE_COLOR_SORT_OPTIONS = [ALL_CHANNELS, DEMAND_GEN, DEMAND_CAP];
export const DEFAULT_SORT_OPTIONS = [...SINGLE_COLOR_SORT_OPTIONS, DEMAND_GEN_VS_CAP];
